// components/NotificationPermissionPrompt.jsx
import { useState, useEffect } from 'react';
import { Bell } from 'lucide-react';

export function NotificationPermissionPrompt({ 
  isOpen, 
  onAccept, 
  onDecline, 
  onLater,
  context = "receber notificações sobre vagas e atualizações importantes"
}) {
  const [show, setShow] = useState(isOpen);

  useEffect(() => {
    setShow(isOpen);
  }, [isOpen]);

  if (!show) return null;

  return (
    <div className="notification-prompt-overlay">
      <div className="notification-prompt-modal">
        <div className="notification-prompt-icon">
          <Bell size={48} />
        </div>
        
        <h2>🔔 Não perca nada importante!</h2>
        
        <p>
          Ative as notificações para {context}. 
          Assim você fica sabendo em tempo real sobre:
        </p>
        
        <ul>
          <li>✅ Vagas prestes a começar</li>
          <li>✅ Novas propostas e mensagens</li>
          <li>✅ Atualizações de status</li>
        </ul>
        
        <div className="notification-prompt-actions">
          <button 
            className="btn-accept"
            onClick={onAccept}
          >
            Sim, quero receber
          </button>
          
          <button 
            className="btn-later"
            onClick={onLater}
          >
            Depois
          </button>
          
          <button 
            className="btn-decline"
            onClick={onDecline}
          >
            Não, obrigado
          </button>
        </div>
        
        <small>Você pode mudar isso a qualquer momento nas configurações.</small>
      </div>
    </div>
  );
}